// Minimal IFA portal shell: an adviser, signed in, looking at a client, with the
// "Upload call recording" entry point into the Call-to-Claim flow.
//
// Component idiom: the KareHero MUI design system (lib/llama theme/mui - see
// the mui-stories Storybook). Plain MUI components, styled by the branded
// theme; no hardcoded colors/radii. Vez's pwa atoms where they fit.

import { useNavigate } from 'react-router-dom';
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import { PageHeader } from '@karehero/llama/pwa/atoms/PageHeader/PageHeader';
import { SAMPLE_CLIENT } from './fixtures';

export default function IfaPortalShell() {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh' }}>
      <AppBar position='static'>
        <Toolbar>
          <Typography sx={{ letterSpacing: 0.4 }}>KareHero</Typography>
          <Typography sx={{ ml: 1, opacity: 0.8 }}>Adviser Portal</Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Avatar sx={{ width: 32, height: 32, fontSize: 14 }}>JC</Avatar>
        </Toolbar>
      </AppBar>

      <Container maxWidth='md' sx={{ py: 4 }}>
        <PageHeader
          variant='h4'
          title='Your clients'
          description="Upload a recording of an Attendance Allowance call and we'll draft the government form for you to check."
        />

        <Card variant='outlined' sx={{ mt: 3 }}>
          <CardContent>
            <Stack sx={{ alignItems: 'center' }} direction='row' spacing={2}>
              <Avatar>AW</Avatar>
              <Box sx={{ flexGrow: 1 }}>
                <Typography>{SAMPLE_CLIENT.name}</Typography>
                <Typography variant='body2' color='text.secondary'>
                  Attendance Allowance · new claim
                </Typography>
              </Box>
              <Chip label='Not started' size='small' />
            </Stack>
            <Stack direction='row' sx={{ justifyContent: 'flex-end', mt: 2 }}>
              <Button
                variant='contained'
                size='large'
                onClick={() => navigate('/aa-claim/upload')}
              >
                Upload call recording
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}
